import React, { useState } from "react";
// import Header from "../../../Common/header";
import Sidebar from "../../../Common/Sidebar";
import CustomLoader from "../../../Components/CustomLoader/CustomLoader";
import Header from "../../../Common/Header";

function AddBooking() {
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      // Add API call here later
      await new Promise(resolve => setTimeout(resolve, 1000)); // Mock API call
      alert('Booking added successfully');
    } catch (error) {
      console.error('Error adding booking:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Header />
      <Sidebar />
      <div className="content-page">
        <CustomLoader loading={loading} />
        <div className="content">
          <div className="container-fluid">
            <div className="py-3 d-flex align-items-sm-center flex-sm-row flex-column">
              <div className="flex-grow-1">
                <h4 className="fs-18 fw-semibold m-0">Add Booking</h4>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <div className="card" style={{ background: "none" }}>
                  {/* <div className="card-header">
                      <h5 className="card-title mb-0">Input Type</h5>
                    </div> */}

                  <div className="card-body">
                    <div className="row">
                      <div className="col-lg-12">
                        <form onSubmit={handleSubmit}>
                          <div className="row">
                            <div className="col-md-4">
                              <div className="mb-3">
                                <label htmlFor="simpleinput" className="form-label">
                                  First Name *
                                </label>
                                <input
                                  type="text"
                                  id="simpleinput"
                                  className="form-control"
                                />
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="mb-3">
                                <label htmlFor="simpleinput" className="form-label">
                                  Providers
                                </label>
                                <input
                                  type="text"
                                  id="simpleinput"
                                  className="form-control"
                                />
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="mb-3">
                                <label htmlFor="example-email" className="form-label">
                                  Email
                                </label>
                                <input
                                  type="email"
                                  id="example-email"
                                  name="example-email"
                                  className="form-control"
                                  placeholder="Email"
                                />
                              </div>
                            </div>
                            
                              <div className="col-md-4">
                                <div className="mb-3">
                                  <label
                                    htmlFor="example-select"
                                    className="form-label"
                                  >
                                    Input Select
                                  </label>
                                  <select
                                    className="form-select"
                                    id="example-select"
                                  >
                                    <option>1</option>
                                    <option>2</option>
                                    <option>3</option>
                                    <option>4</option>
                                    <option>5</option>
                                  </select>
                                </div>
                              </div>
                              <div className="col-md-4">
                                <div className="mb-3">
                                  <label
                                    htmlFor="example-select"
                                    className="form-label"
                                  >
                                    Input Select
                                  </label>
                                  <select
                                    className="form-select"
                                    id="example-select"
                                  >
                                    <option>1</option>
                                    <option>2</option>
                                    <option>3</option>
                                    <option>4</option>
                                    <option>5</option>
                                  </select>
                                </div>
                              </div>
                              <div className="col-md-4">
                                <div className="mb-3">
                                  <label htmlFor="example-date" className="form-label">
                                    Date
                                  </label>
                                  <input
                                    type="date"
                                    id="example-date"
                                    className="form-control"
                                    name="date"
                                  />
                                </div>
                              </div>
                            
                            
                              <div className="col-md-4">
                              <div className="mb-3">
                              <label htmlFor="example-password" className="form-label">
                                Password
                              </label>
                              <input
                                type="password"
                                id="example-password"
                                className="form-control"
                                value="password"
                              />
                            </div>
                              </div>
                              <div className="col-md-4">
                              <div className="mb-3">
                              <label htmlFor="example-password" className="form-label">
                                Password
                              </label>
                              <input
                                type="password"
                                id="example-password"
                                className="form-control"
                                value="password"
                              />
                            </div>
                              </div>
                              <div className="col-md-4">
                              <div className="mb-3">
                                  <label
                                    htmlFor="example-select"
                                    className="form-label"
                                  >
                                    Input Select
                                  </label>
                                  <select
                                    className="form-select"
                                    id="example-select"
                                  >
                                    <option>1</option>
                                    <option>2</option>
                                    <option>3</option>
                                    <option>4</option>
                                    <option>5</option>
                                  </select>
                                </div>
                              </div>
                              <div className="col-md-4">
                              <div className="mb-3">
                              <label htmlFor="example-password" className="form-label">
                                Password
                              </label>
                              <input
                                type="password"
                                id="example-password"
                                className="form-control"
                                value="password"
                              />
                            </div>
                              </div>
                              <div className="col-md-4">
                              <div className="mb-3">
                                  <label
                                    htmlFor="example-select"
                                    className="form-label"
                                  >
                                    Input Select
                                  </label>
                                  <select
                                    className="form-select"
                                    id="example-select"
                                  >
                                    <option>1</option>
                                    <option>2</option>
                                    <option>3</option>
                                    <option>4</option>
                                    <option>5</option>
                                  </select>
                                </div>
                              </div>
                            
                            </div>
                          

                          
                          <button type="submit" className="btn btn-primary">
                            Submit
                          </button>
                        </form>
                      </div>

                      
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddBooking;
